module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fuBRJ"))).then(() => parcelRequire('9Lwss'));